/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a given `lang` is invalid
 * @export
 * @class I18nInvalidLangTypeError
 * @extends {Error}
 */
export class I18nInvalidLangTypeError extends Error {
  /**
   * Creates an instance of I18nInvalidLangTypeError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidLangTypeError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidLangTypeError`;
  }
}

/**
 * Called when the type of a given `lang` is invalid
 * @param {any} lang The invalid `lang`
 * @returns {never} never
 */
const throwI18nInvalidLangTypeError = (lang) => {
  throw new I18nInvalidLangTypeError(
    stripIndent(`
    Expected "lang" to be of type String.
    Got: "${ctype(lang)}".
    `),
  );
};

export default throwI18nInvalidLangTypeError;
